// extracted by mini-css-extract-plugin
export default {"powered-by":"Powered_powered-by__bVT+2","label":"Powered_label__1TaIJ","imgContainer":"Powered_imgContainer__cMfj8","img":"Powered_img__gYa3I"};